<template>
	<module class="module-config" :drag="false" gap="10">
		<module-col title="报表配置" size="55%">
			<c-form ref="form" vertical unit-width="100%">
				<c-form-item label="报表名称" required>
					<c-input v-model="data.name" name="name"></c-input>
				</c-form-item>
				<c-form-item label="数据源" required>
					<c-select v-model="data.source" name="source" :options="listDataSource" :clear="false" @change="sourceHandle"></c-select>
				</c-form-item>
				<c-form-item label="显示数据条数" required>
					<c-input v-model="data.total" name="total" type="stepper" range="1,100" step-controls="side" :clear="false"></c-input>
				</c-form-item>
				<c-form-item label="刷新间隔时间" required>
					<c-select v-model="data.refresh" name="refresh" :options="refreshTimeOptions" :clear="false"></c-select>
				</c-form-item>
				<c-form-item label="滚动方式" required>
					<c-radio-group v-model="data.autoScroll" name="autoScroll">
						<c-radio value="1">自动滚动</c-radio>
						<c-radio value="0">手动滚动</c-radio>
					</c-radio-group>
				</c-form-item>
				<c-form-item v-show="data.autoScroll == 1" label="滚动间隔时间" required>
					<c-select v-model="data.autoSpan" name="autoSpan" :options="autoSpanOptions" :clear="false"></c-select>
				</c-form-item>
				<c-form-item label="数据过滤">
					<data-filter ref="dataFilter"></data-filter>
				</c-form-item>
				<c-form-item label="默认排序">
					<data-sort ref="dataSort"></data-sort>
				</c-form-item>
			</c-form>
		</module-col>

		<module-col title="列配置" enable-flex>
			<field-config ref="fieldConfig" class="flex-grow flex-column" private :fixed-button="false"></field-config>
		</module-col>
	</module>
</template>

<script>
	import dataFilter from '@/components/view/data_filter.vue'
	import dataSort from '@/components/view/data_sort.vue'
	import fieldConfig from '@/components/view/field_config.vue'
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	export default {
		components: {
			dataFilter,
			dataSort,
			fieldConfig
		},

		props: {
			config: [Object]
		},

		data() {
			return {
				...getStore(this),
				data: {
					name: '',
					source: '',
					field: null,
					total: 50,
					refresh: 300,
					autoScroll: 1,
					autoSpan: 3
				},
				autoSpanOptions: [{
					name: '3秒',
					value: 3
				}, {
					name: '5秒',
					value: 5
				}, {
					name: '7秒',
					value: 7
				}, {
					name: '10秒',
					value: 10
				}, {
					name: '15秒',
					value: 15
				}]
			}
		},

		computed: {
			...mapStore(['listDataSource', 'refreshTimeOptions'])
		},
		
		watch: {
			listDataSource() {
				this.init();
			},

			'data.source'(val, old) {
				let valData = this.listDataSource.find(opt => opt.value == val);
				let oldData = this.listDataSource.find(opt => opt.value == old);
				if (!this.data.name.trim() || (oldData && this.data.name.trim() == oldData.name)) {
					this.data.name = valData.name;
				}
			}
		},

		mounted() {
			this.store.getDataSource('list');
		},

		methods: {
			init() {
				if (this.listDataSource.length && !this.data.source) {
					this.data.source = this.listDataSource[0].value;
				}
				this.$refs.dataFilter.set(this.data.source, this.data.filter || []);
				this.$refs.dataSort.set(this.data.source, this.data.sort || []);
				this.updateField();
			},

			updateField() {
				if (this.data.field) {
					this.$refs.fieldConfig.set(this.data.field);
				} else if (this.data.source) {
					this.request({
						url: '/sys_user_view/manage/info',
						data: {
							work_type_id: this.data.source
						},
						success: data => {
							this.$refs.fieldConfig.set(data.field_list);
						}
					});
				}
			},

			sourceHandle() {
				this.data.field = null;
				this.$refs.dataFilter.set(this.data.source, []);
				this.$refs.dataSort.set(this.data.source, []);
				this.updateField();
			},

			setConfig(config) {
				if (config) {
					Object.assign(this.data, config.data);
				}	
				this.init();
			},

			getConfig() {
				return new Promise(resolve => {
					let field = this.$refs.fieldConfig.get();
					this.$refs.form.validate({
						rule: {
							name: '请填写指标名称',
							source: '请选择数据源',
							total: '请填写显示数据条数',
							field: [{
								type: 'function',
								fun: () => {
									return field.length;
								}
							}]
						},
						success: () => {
							resolve({
								type: 3,
								data: Object.assign(this.data, {
									field,
									filter: this.$refs.dataFilter.get(),
									sort: this.$refs.dataSort.get()
								})
							});
						},
						fail: () => {
							resolve(false);
						}
					});
				})
			}
		}
	}
</script>